import {CheckoutController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {GooglePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_googlepay_data');

const context = new Context(getPage());

const gateway = new GooglePayGateway({
    id: 'stripe_googlepay',
    settings,
    context
});

const controller = new CheckoutController({
    context,
    gateway,
    selector: '#wc-stripe_googlepay-checkout-button'
});

controller.initialize();